<mat-form-field class="jump-to-section" appearance="fill">
  <mat-select
    placeholder="Jump To"
    [(value)]="selected"
    (selectionChange)="jumpTo($event)"
    >
    @for (section of sections; track section) {
      @if (!section.subSections) {
        <mat-option [value]="section.id">{{
          section.name
        }}</mat-option>
      }
      @if (!!section.subSections) {
        @for (subSection of section.subSections; track subSection) {
          <mat-option
            [value]="subSection.id"
            >{{ subSection.name }}</mat-option
            >
          }
        }
      }
    </mat-select>
  </mat-form-field>
